export const scrollPage = (x: number, y: number): void => {
  if ('parentIFrame' in window) {
    window.parentIFrame.scrollTo(x, y)
  }
}
